import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

export const subscribeToNewsletter = async (email) => {
  const response = await api.post('/newsletter/subscribe', { email });
  return response.data;
};

export const unsubscribeFromNewsletter = async (email) => {
  const response = await api.post('/newsletter/unsubscribe', { email });
  return response.data;
};

export const verifySubscription = async (token) => {
  const response = await api.get(`/newsletter/verify/${token}`);
  return response.data;
};